<template>
  <div v-if="isLoadingAuth" class="flex items-center justify-center h-screen">
    <div class="animate-spin rounded-full h-12 w-12 border-t-4 border-indigo-600"></div>
  </div>
  <div v-else-if="!user" class="text-red-500 text-center p-4">
    User not logged in
  </div>
  <div v-else class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="fixed inset-0 bg-gray-900 bg-opacity-70 transition-opacity duration-300"></div>
    <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
      <div class="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
        <div class="relative transform overflow-hidden rounded-lg bg-gray-800 text-left shadow-xl transition-all sm:my-8 w-full sm:max-w-md">
          <div class="p-5">
            <!-- Header -->
            <div class="flex justify-between items-center mb-4">
              <h2 class="text-xl font-semibold text-yellow-400" id="modal-title">
                <i class="fas fa-exclamation-triangle mr-2"></i>พบข้อผิดพลาด
              </h2>
            </div>

            <div class="space-y-4">
              <p class="text-indigo-200 text-sm text-center">
                ข้อมูลการเกิดใหม่หายไปจากระบบ (อาจถูกลบโดยไม่ตั้งใจ)<br>
                กรุณากดปุ่มด้านล่างเพื่อฟื้นฟูสถานะตัวละคร
              </p>

              <div class="bg-yellow-700/30 border border-yellow-600 rounded-md p-3">
                <p class="text-yellow-200 text-xs text-center">
                  <i class="fas fa-info-circle mr-1"></i>
                  หมายเหตุ: เนื่องจากไม่พบข้อมูลบทลงโทษ ตัวละครจะเกิดใหม่โดยไม่สูญเสียเพิ่มเติม
                </p>
              </div>

              <div v-if="errorMessage" class="text-red-300 text-center text-sm">
                {{ errorMessage }}
              </div>

              <button
                @click="handleRecover"
                :disabled="loading"
                class="w-full bg-green-600 hover:bg-green-700 text-white py-2 rounded-md text-sm font-medium transition-colors duration-200 flex justify-center items-center disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <span v-if="!loading">เกิดใหม่</span>
                <div v-else class="animate-spin rounded-full h-4 w-4 border-t-2 border-white"></div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { projectFunctions } from '@/firebase/config';
import getUser from '@/composables/getUser';

export default {
  emits: ['recoverCompleted'],
  setup(props, { emit }) {
    const { user, isLoadingAuth } = getUser();
    const loading = ref(false);
    const errorMessage = ref('');

    const handleRecover = async () => {
      if (loading.value || !user.value) return;
      loading.value = true;
      errorMessage.value = '';

      try {
        const gameActionsFunction = projectFunctions.httpsCallable('gameActions');
        const result = await gameActionsFunction({ action: 'bornActions', subAction: 'recover' });
        if (!result.data.success) {
          throw new Error(result.data.message || 'การฟื้นฟูสถานะล้มเหลว');
        }
        emit('recoverCompleted');
      } catch (err) {
        errorMessage.value = err.message || 'เกิดข้อผิดพลาดในการฟื้นฟูสถานะ';
      } finally {
        loading.value = false;
      }
    };

    return {
      user,
      isLoadingAuth,
      loading,
      errorMessage,
      handleRecover,
    };
  },
};
</script>

<style scoped>
.animate-spin {
  animation: spin 1s linear infinite;
}
@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>
